import { useEffect, useState } from "react";
import { cmsAdminApi } from "../../api/cmsApi";

export default function AdminContactInquiriesPage() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  const [error, setError] = useState("");

  const refresh = async () => {
    try {
      setItems(await cmsAdminApi.listContactInquiries());
      setError("");
    } catch (e) {
      setError(e.message || "Could not load contact inquiries");
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const filtered = filter === "all" ? items : items.filter((i) => i.status === filter);

  return (
    <div className="admin-page">
      <header className="admin-page-head">
        <div>
          <h1>Contact Inquiries</h1>
          <p>Messages from the Contact Us page and support forms.</p>
        </div>
      </header>
      {error ? <p className="text-danger">{error}</p> : null}

      <div className="admin-panel mb-3">
        <div className="d-flex flex-wrap gap-2 align-items-center">
          <span className="text-muted small text-uppercase fw-bold me-1">Filter</span>
          {["all", "new", "contacted", "closed"].map((f) => (
            <button
              key={f}
              type="button"
              className={`admin-btn admin-btn-sm${filter === f ? " admin-btn-primary" : " admin-btn-ghost"}`}
              onClick={() => setFilter(f)}
            >
              {f === "all" ? "All" : f}
            </button>
          ))}
        </div>
      </div>

      <div className="admin-panel">
        {filtered.length === 0 ? (
          <p className="admin-empty">No contact inquiries yet.</p>
        ) : (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Contact</th>
                  <th>Service</th>
                  <th>Message</th>
                  <th>Status</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {filtered.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <strong>{item.name}</strong>
                      <div className="text-muted small">{item.email}</div>
                      <div className="text-muted small">{item.phone || "—"}</div>
                      <div className="text-muted small">{new Date(item.createdAt).toLocaleString()}</div>
                    </td>
                    <td>
                      <strong>{item.service || "—"}</strong>
                      <div className="text-muted small">{item.company || "—"}</div>
                      <div className="text-muted small">{item.source || "contact"}</div>
                    </td>
                    <td>
                      <div className="admin-inquiry-msg" title={item.message}>
                        {item.message || "—"}
                      </div>
                    </td>
                    <td>
                      <select
                        className="admin-select-sm"
                        value={item.status}
                        onChange={async (e) => {
                          await cmsAdminApi.updateContactInquiryStatus(item.id, e.target.value);
                          await refresh();
                        }}
                      >
                        <option value="new">new</option>
                        <option value="contacted">contacted</option>
                        <option value="closed">closed</option>
                      </select>
                    </td>
                    <td className="admin-actions">
                      <button
                        type="button"
                        className="admin-btn admin-btn-sm admin-btn-danger"
                        onClick={async () => {
                          if (!window.confirm("Delete this inquiry?")) return;
                          await cmsAdminApi.deleteContactInquiry(item.id);
                          await refresh();
                        }}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
